import React from 'react'

function ContactDetailsBannerBadge({DECISION_MAKER_STAT,BANT_FRAMEWORK}) {
      console.log("ContactDetailsBannerBadge",DECISION_MAKER_STAT?.confidence_level)
  return (
    <div className="contact-banner-decision-wrapper">
          <div
            className={`contact-banner-decision-badge ${DECISION_MAKER_STAT?.confidence_level || "High"}`}
          >
            ✓ {DECISION_MAKER_STAT?.display_label || "Low"}
          </div>
          <div className="decision-tooltip">
            {Object?.entries(BANT_FRAMEWORK).map(([key, value]) => (
              <div key={key} className="decision-tooltip-section">
                <strong className="decision-key">{key.toUpperCase()}</strong>:{" "}
                <span className="decision-value">{value.status}</span>
                <div className="decision-hover-text">{value.hover_context}</div>
              </div>
            ))}
          </div>
        </div>
  )
}

export default ContactDetailsBannerBadge